<template>
  <div class="containerTable" style="padding: 15px;">
    <vxe-toolbar
      id="toolbarId_fa5"
      :custom="{ storage: true }"
      export
      :buttons="toolbarButtons"
      :refresh="{ query: RefreshList }"
    />
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :footer-method="footerMethod"
      :checkbox-config="{ highlight: true }"
      :loading="loading"
      :data="tableData"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="reviewer"
          title="操作"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="是否超载"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="reviewer"
          title="支付批次号"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="运输单号"
          min-width="300"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="运输公司"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="运单关联企业"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="收款方姓名"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="收款方账户"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="金额"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="实际承运人实际运费"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="实际承运人实收现金"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="油气卡"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="手续费"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="收款方手机号"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="银行名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="转账请求状态"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="转账结果"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="流水上报"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="电子路单上报状态"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="到账时间"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="pageviews"
          title="操作人"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input v-model="message" placeholder="请输入内容" clearable />
        </template>
      </vxe-table-column>

      <vxe-table-column title="操作" min-width="130" fixed="right">
        <template>
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <vxe-button type="text">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <vxe-button type="text">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.page"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.limit"
      :total="listQuery.totalzong"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { fetchList } from "@/api/article";

export default {
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      listQuery: {
        page: 1,
        limit: 20,
        totalzong: 0
      },
      Pagingconf: [],
      toolbarButtons: [
        {
          code: "btn1",
          name: "查询"
        },
        {
          name: "下拉按钮",
          dropdowns: [
            {
              name: "按钮111",
              code: "btn2"
            },
            {
              name: "按钮222",
              code: "btn3"
            }
          ]
        }
      ]
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      fetchList(this.listQuery).then(response => {
        this.tableData = response.data.items;
        this.listQuery.totalzong = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.loading = false;
      });
    },

    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.page = currentPage;
      this.listQuery.limit = pageSize;
      this.findList();
    } /* 
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return 'col-blue'
        } else {
          return 'col-red'
        }
      }
    }, */,
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "平均";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.mean(data, column.property);
          }
          return null;
        }),
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "和值";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>
<style></style>
